import { useCrmEnrichmentJobCache } from "../../../hooks/useCrmEnrichmentJobCache";
import { salesforceEnrichmentQueryKeys } from "../query/key-factory";

export const useSfEnrichmentJobCache = () => useCrmEnrichmentJobCache(salesforceEnrichmentQueryKeys);
